<template>
  <div class="right_body">
    <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
	<list-btn isEdit @edit="onEdit"></list-btn>
    <tab-list
      :tabList="listArr"
      :total="total"
      :pages="pages"
      :fromData="fromData"
      :columns="tabColumns"
      tabName="purchase_order_search"
      @currentChange="currentChange"
      @changePages="changePages"
      @selectSdata="selectSdata"
      @dbClick="dbClick"
    ></tab-list>

    <!-- 详情 -->
    <!-- <el-dialog title="采购订单详情"
    :visible.sync="isPreviewPurchaseOrder"
    customClass="dialog_detail_style"
    v-dialogDrag @closed="closedDialog" >
      <v-detail :sdata="detailSdata" class="contnet_box" ></v-detail> 
    </el-dialog>-->

    <!-- 详情 -->
    <el-dialog
      title="采购订单详情"
      customClass="dialog_detail_style"
      v-dialogDrag
      :visible.sync="isPreviewPurchaseOrder"
      @closed="closedDialog"
    >
      <v-detail :sdata="detailSdata" class="contnet_box"></v-detail>
    </el-dialog>
  </div>
</template>

<script>
import { purchaseinstock } from "api/business.js";
import listBtn from "components/btn/listBtn.vue";
import tabList from "components/table/list.vue";
import searchBox from "./components/Search/PurchOrdersearch.vue";
import vDetail from "./components/bomDetail.vue";

export default {
  components: {
    listBtn,
    tabList,
    searchBox,
    vDetail
  },
  data() {
    return {
      isPreviewPurchaseOrder: false,
      detailSdata: {},
      sdata: {},
      listArr: [],
      tabColumns: [
        {
          field: "purchaseOrderNo",
          title: "采购订单号",
          need: true,
          sortable: true
        },
        { field: "companyCode", title: "公司编码" },
        { field: "companyName", title: "公司描述" },
        { field: "supplierCode", title: "供应商编码" },
        { field: "supplierDesc", title: "供应商描述" },
        { field: "createDate", title: "单据日期", sortable: true }
      ], //表头字段
      total: 0, //总条数
      pages: 0, //总页数
      fromData: {
        page: 1, //当前页
        pageSize: 20, //每页显示的数量,
        searchCriteria: {
          //查询的附加条件
        }
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //双击
    dbClick(data) {
      this.sdata = data;
      this.goDetail();
    },
    //选中数据
    selectSdata(data) {
      this.sdata = data;
    },
    //获取列表
    async getList() {
      let res = await this.$post(
        "purchasemng/purchaseOrder/list",
        this.fromData
      );
      if (res.status && res.data) {
        this.pages = res.data.pages;
        this.listArr = res.data.list;
        this.total = res.data.total;
      } else {
        this.pages = 0;
        this.listArr = [];
        this.total = 0;
      }
    },
    //当前页码改变
    currentChange(currentPage) {
      this.fromData.page = currentPage;
      this.getList();
    },
    //页码条数改变
    changePages(pages) {
      this.fromData.page = 1;
      this.fromData.pageSize = pages;
      this.getList();
    },
    //搜索
    subSearch() {
      this.fromData.page = 1;
      this.getList();
    },
    handleSelectChange(item, key) {
      if (item.isChecked) {
        item.isChecked = false;
        this.sdata = {};
      } else {
        this.sdata = item;
        this.sdata.index = key;
        item.isChecked = true;
        this.listArr.forEach(items => {
          if (items.purchaseOrderId != item.purchaseOrderId) {
            items.isChecked = false;
          }
        });
      }
    },
    //选择的改变
    changeSelect(val, item, key) {
      this.handleSelectChange(item, key);
    },
    //详情
    async goDetail() {
      if (!this.sdata.purchaseOrderId) {
        this.$message.error("请选择要查看的记录");
        return;
      }
      let res = await this.$get("purchasemng/purchaseOrder/select", {
        purchaseOrderId: this.sdata.purchaseOrderId
      });

      this.isPreviewPurchaseOrder = true;
      if (res.status) {
        //console.log(res)
        this.detailSdata = res.data.details;
      }
    },
    //关闭弹出层 
    closedDialog() {
      this.isPreviewPurchaseOrder = false;
	} 
	 //编辑
    ,onEdit(){
        if(!this.sdata.purchaseOrderId) {
              this.$message.error('请选择需要编辑的记录');
              return;
           }    
          // this.$router.push({name: 'business-purchaseorder-purchaseorderedit', params:{id:this.sdata.purchaseOrderId}});
          this.$keepAliveManager.pushRouter(this,{name: 'business-purchaseorder-purchaseorderedit', params:{id:this.sdata.purchaseOrderId}});
    },
  }
};
</script>

<style lang="stylus" scoped></style>